module.exports = __webpack_public_path__ + "static/media/new2@2x.bd594ca7.png";